
import { useTranslation } from 'react-i18next';
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';

export default function GoBack() {
    const {  i18n } = useTranslation();
    const lang = i18n.language;
    const navigate = useNavigate();
    return (
        <div
            onClick={() => navigate(-1)}
            className="flex size-fit items-center cursor-pointer gap-2 rounded-md p-2 duration-150 mb-5 hover:bg-black/10"
        >

            {lang === "ar" ? (
                <IoMdArrowRoundForward size={26} />
            ) : (
                <IoMdArrowRoundBack size={26} />
            )}
        </div>
    )
}
